var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{attrs:{"sitekey":"6LeBScQZAAAAAMtI0CJ5krbVZe625u3hZIx9PK7Y","loadRecaptchaScript":true},on:{"verify":_vm.onVerify}})}
var staticRenderFns = []

export { render, staticRenderFns }